export default class Directory {
    constructor(name) {
        this._name = name;
    }

    getName() {
        return this._name;
    }
}